import Vue from 'vue';
import ContactList from '@/components/contact-list/contact-list.vue';
import LoginService from '@/services/login.service';
import DataFormParameters from '@/models/data-form-parameters';
import BrowserDialog from '@/components/common/browser-dialog.vue';
import { IsNull } from '@/utils/utils';

Vue.prototype.$isMobile = false;

/**
 * 参数 deptInfo
 * {
 *    title: '', 对话框的标题
 *    width: '', 对话框的宽度,默认1208px
 *    showFooter: false, 是否显示确定取消按钮
 *
 *
 *    Name: '', 部门名称
 *    ID:  '', 部门的ObjectID
 *    UnitType: '', // 部门类型
 * }
 */
window.global = {
    openContactListDialog: function(options = {}) {
        Vue.prototype.$modal.show({
            title: options.title,
            content: ContactList,
            width: options.width || '1208px',
            minHeight: options.minHeight || '555px',
            showFooter: options.showFooter || false,
            componentParams: {
                dept: {
                    Name: options.Name || LoginService.userInfo.CompanyName,
                    ObjectID: options.ObjectID || LoginService.userInfo.CompanyID,
                    UnitType: options.UnitType || LoginService.userInfo.UnitType,
                },
            },
        });
    },
};

Vue.prototype.$quickModal = {
    showFormModal(parameters, actionHandler) {
        const params = new DataFormParameters(parameters);
        return Vue.prototype.$modal.show({
            content: () =>
                import(
                    /* webpackChunkName: "form-info" */
                    '@/components/data-form/form-info.vue'
                ),
            fullscreen: true,
            showFooter: false,
            componentParams: {
                parameters: params,
            },
            componentOn: {
                'form-operation-trigger': dataFormAction => {
                    if (typeof actionHandler === 'function') {
                        actionHandler(dataFormAction);
                    }
                },
            },
        });
    },

    /*
        弹出Iframe模态，封装了和iframe的通信，下面是例子：
        this.$quickModal.showIframeModal({
            url: 'https://www.baidu.com',
                width: '70%',
                height: '500px',
                confirmHandler: messageData => {
                    if (messageData && messageData.act === 'Refresh') {
                        this.$message({
                            type: 'success',
                            message: '操作成功',
                        });
                    }
                },
            });
    */
    showIframeModal(options) {
        if (IsNull(options.url)) return;

        return Vue.prototype.$modal.show({
            title: options.title,
            content: BrowserDialog,
            width: options.width || '50%',
            height: options.height,
            showFooter: false,
            componentParams: {
                url: options.url,
            },
            confirmHandler: messageData => {
                if (typeof options.confirmHandler === 'function') {
                    options.confirmHandler(messageData);
                }
            },
            cancelHandler: () => {
                if (typeof options.cancelHandler === 'function') {
                    options.cancelHandler();
                }
            },
        });
    },
};

Vue.prototype.$getUserInfo = () => {
    if (LoginService.isLogin) {
        return LoginService.userInfo;
    } else {
        return null;
    }
};
